import React from 'react';
import _ from 'lodash';
import moment from "moment";

import JsonValidator from '../..//lib/JsonValidator';
import { useAuth } from 'oidc-react';

const Context = React.createContext();

export const AuthenticationProvider = ({ children }) => {
    const [loading, setLoading] = React.useState(true);
    const auth = useAuth();

    React.useEffect(() => {
        if (auth && auth.userData) {
            setLoading(false);
        }
    }, [auth]);

    const logout = React.useCallback(async () => {
        await auth.signOutRedirect();
    }, [auth]);

    const fetchAuthData = React.useCallback(() => {
        const user = auth.userData;
        const authObject = localStorage.getItem('authData');
        let valid = (authObject && JsonValidator(authObject) && user);

        if (valid) {
            const authData = JSON.parse(authObject);
            valid = (user.access_token !== undefined && user.expires_at !== undefined);

            if (valid) {
                const combinedAuthData = {
                    accessToken: user.access_token,
                    refreshToken: user.refresh_token,
                    expireDate: moment
                        .unix(user.expires_at)
                        .format("YYYY-MM-DDTHH:mm:ss.sssZ"),
                    fullName: user.profile.name,
                    username: user.profile.preferred_username,
                    roles: authData['roles'],
                    permissions: authData['permissions'],
                };
                return combinedAuthData;
            };
        }

        return null;
    }, [auth]);

    const validate = React.useCallback(() => {
        const authData = fetchAuthData();
        let valid = false;

        if (!_.isEmpty(authData) && !_.isEmpty(authData.accessToken)) {
            if (!_.isEmpty(authData.roles)) {
                valid = authData.roles.includes("fm");
            }
        }

        return valid;
    }, []);

    if (loading) {
        return <div>Loading...</div>;
    }

    const value = { fetchAuthData, logout, validate };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useAuthenticationStore = () => React.useContext(Context);